import styled from 'styled-components'

export const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;

  div,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const Illustration = styled.div`
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`
